import React, { Component } from 'react'
import Layout from '../Layout/Layout'
import styled from 'styled-components'
import Image from './../Image/Image'
import Router from 'next/router'
import { get, headers } from '../../lib/fetch'
import { Button, ConfigProvider, Title } from '@ntuctech/tangram-web'
import { SCREEN_SIZE } from '../../lib/Media'
import ProductCollection from '../ProductCollection/ProductCollection'
import tangramNextConfig from '../../lib/tangramNextConfig'
import { generateQueryString } from '../../utils/Utils'
import { getActiveExperimentVariants } from '../../lib/getActiveExperimentVariants'
import { getDyFBTExperiments } from '../../utils/DyUtils'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import { getPageTypeByUrl } from '../../lib/amplitude'
import { getCtaLocationMeta } from '../../lib/utils'

const zeroSearchResultImage = {
  '1x': 'https://media.nedigital.sg/fairprice/images/977f244d-80a0-4f72-a930-cd9a81da6f7b/no_search_result.png',
  '2x': 'https://media.nedigital.sg/fairprice/images/56b5c0eb-5062-443f-9127-2f9c5d217db6/no_search_result_2x.png',
  '3x': 'https://media.nedigital.sg/fairprice/images/24a24fcd-d342-4652-9122-7d61ad70d838/no_search_result_3x.png',
}

const Container = styled.div`
  padding-top: 1.6875rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${SCREEN_SIZE.From.Tablet} {
    padding-top: 1.5rem;
  }
`

const Description = styled.div`
  margin: 0.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CenterText = styled.div`
  text-align: center;
`

const BackHomeButton = styled(Button)`
  margin: 0.5rem 0;
`

const SwimlaneWrapper = styled.div`
  margin: 2.5rem auto 0;
`

const getZeroSearchSwimlaneConfiguration = () => {
  const { configuration, isEnabled } = getConfigFor(
    SPLIT_FEATURES.FE_ZERO_SEARCH_SWIMLANE_ENABLED
  )

  if (!isEnabled) {
    return {}
  }

  return {
    title: 'Recommended for you',
    configId: 'homepage_r4u_config_a',
    ...configuration,
  }
}

class NewEmptySearchResult extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMounted: false,
      availableRecommendedProductData: {},
    }
    this.handleOnButtonClick = this.handleOnButtonClick.bind(this)
  }

  async componentDidMount() {
    this.setState({
      isMounted: true,
    })
    const { storeId } = this.props

    const activeExperiments = getActiveExperimentVariants()
    const fbtExperiments = getDyFBTExperiments(true)
    const experiments = fbtExperiments
      ? `${activeExperiments},${fbtExperiments}`
      : activeExperiments

    const experimentsWithoutDy = experiments.replace('rec-r4u-dy', 'rec-r4u-ds')
    const { title, configId } = getZeroSearchSwimlaneConfiguration()

    const queryParams = generateQueryString({
      personalisationApi: configId,
      pageType: configId,
      personalisationType: configId,
      title: title,
      page: 1,
      storeId: storeId,
      includeTagDetails: true,
      orderType: 'DELIVERY',
      hasStock: false,
      experiments: experimentsWithoutDy,
    })

    const recommendedItemResponse = await get(`product/v2${queryParams}`, {
      headers: headers(),
    })

    const availableRecommendedProductData = recommendedItemResponse?.data || {}

    this.setState({
      availableRecommendedProductData,
    })
  }

  handleOnButtonClick(e) {
    e.preventDefault()
    Router.push('/')
  }

  render() {
    const { isMounted, availableRecommendedProductData } = this.state
    const { title, configId } = getZeroSearchSwimlaneConfiguration()

    return (
      <Layout
        noWrapper="default"
        categoryList={this.props.categoryList}
        organizationData={this.props.organizationData}
      >
        <ConfigProvider
          tokens={tangramNextConfig}
          experimental={{
            Button: true,
            Title: true,
            Text: true,
          }}
        >
          <Container>
            <Image
              srcSet={`${zeroSearchResultImage['1x']} 1x, ${zeroSearchResultImage['2x']} 2x, ${zeroSearchResultImage['3x']} 3x`}
              src={`${zeroSearchResultImage['1x']}`}
            />
            <Description>
              <Title size="s">No results found</Title>
              <CenterText size="m">
                Try another search term, or check out the recommended items
                below.
              </CenterText>
            </Description>
            <BackHomeButton
              size="s"
              variant="secondary"
              onClick={this.handleOnButtonClick}
            >
              Back to Home
            </BackHomeButton>
          </Container>
        </ConfigProvider>

        {isMounted && (
          <SwimlaneWrapper>
            <ProductCollection
              isLoading={
                Object.keys(availableRecommendedProductData).length === 0
              }
              key={'recomm-0-search'}
              data={{
                title,
                collection: availableRecommendedProductData,
              }}
              ctaLocation={{
                pageName: getPageTypeByUrl(),
                pageMeta: getCtaLocationMeta() || [],
              }}
              config={{
                'layoutType': 'GRID',
                'loadMoreType': 'SEEALL',
                'personalisationApi': configId,
                'personalisationType': configId,
                'title': title,
                'loc': 'ProductWidget-Recommendedforyou',
                'pageType': configId,
                'ctaSublocation': ['recommended for you'],
                'customListing': 'emptySearchR4u',
              }}
            />
          </SwimlaneWrapper>
        )}
      </Layout>
    )
  }
}

export default NewEmptySearchResult
